import { createFileRoute } from '@tanstack/react-router';
import { ReceiptsRedirectRoute } from './-route-wrappers';

// `/settings/receipts` redirects to Billing history (SPE-3769), behind the same `hydra-billing`
// flag as the rest of billing: flag on, Hydra bounces the URL without booting the embedded app;
// flag off, the embedded app serves it (its own receipts route does the same redirect).
//
// Only the bare path is owned here — `/settings/receipts/:id` is a server-rendered Stripe receipt
// and stays embedded, so this exact route must not match it.
export const Route = createFileRoute('/_authenticated/settings/receipts')({
  component: ReceiptsRedirectRoute,
});
